var _rect, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgDeathBenefitInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39 -16C-39 -22.6274 -33.6274 -28 -27 -28H139C145.627 -28 151 -22.6274 151 -16V159.231C151 165.858 145.627 171.231 139 171.231H-27C-33.6274 171.231 -39 165.858 -39 159.231V-16Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_2721)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0744 34.3875C78.5471 36.8898 79.3189 39.7426 79.309 42.6461C79.309 49.232 76.9963 54.8636 72.0713 59.1371V63.2484C72.0713 65.8732 74.198 68.0009 76.8211 68.0009H77.8641V69.9709C77.8641 72.0866 80.3839 73.7958 82.4981 73.7958H84.8151V78.4324C84.8151 80.3524 86.3712 81.9093 88.2909 81.9093C90.2105 81.9093 91.7661 80.3524 91.7661 78.4324V48.2965C91.7661 40.2106 85.132 34.4319 77.0744 34.3875Z",
    fill: "#B0D2EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8135 74.9553C84.1736 74.9553 83.6553 74.4362 83.6553 73.796V49.456C83.6553 48.8158 84.1736 48.2967 84.8135 48.2967C85.4534 48.2967 85.9723 48.8158 85.9723 49.456V73.796C85.9723 74.4362 85.4534 74.9553 84.8135 74.9553Z",
    fill: "#D6E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8638 69.1595C77.224 69.1595 76.7051 68.6409 76.7051 68.0008V59.8873C76.7051 59.2471 77.224 58.728 77.8638 58.728C78.5037 58.728 79.0221 59.2471 79.0221 59.8873V68.0008C79.0221 68.6409 78.5037 69.1595 77.8638 69.1595Z",
    fill: "#D6E8F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8362 34.3875C38.3635 36.8898 37.5917 39.7426 37.6016 42.6461C37.6016 49.232 39.9149 54.8636 44.8399 59.1371V63.2484C44.8399 65.8732 42.7132 68.0009 40.0896 68.0009H39.0471V69.9709C39.0471 72.0866 36.5262 73.7958 34.4126 73.7958H32.0956V78.4324C32.0956 80.3524 30.5394 81.9093 28.6203 81.9093C26.7007 81.9093 25.1445 80.3524 25.1445 78.4324V48.2965C25.1445 40.2106 31.7786 34.4319 39.8362 34.3875Z",
    fill: "#B0D2EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0948 74.9553C31.4549 74.9553 30.9365 74.4362 30.9365 73.796V49.456C30.9365 48.8158 31.4549 48.2967 32.0948 48.2967C32.7346 48.2967 33.2535 48.8158 33.2535 49.456V73.796C33.2535 74.4362 32.7346 74.9553 32.0948 74.9553Z",
    fill: "#D6E8F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0465 69.1595C38.4066 69.1595 37.8877 68.6409 37.8877 68.0008V59.8873C37.8877 59.2471 38.4066 58.728 39.0465 58.728C39.6863 58.728 40.2047 59.2471 40.2047 59.8873V68.0008C40.2047 68.6409 39.6863 69.1595 39.0465 69.1595Z",
    fill: "#D6E8F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8268 29.5356C64.6828 29.5356 61.8164 30.8682 59.6487 33.058C59.0454 33.6675 58.0764 33.6675 57.4731 33.058C55.305 30.8679 52.4387 29.5356 49.295 29.5356C42.5306 29.5356 37.0459 35.7032 37.0459 43.3125C37.0459 49.9622 42.811 61.2591 55.5793 68.1758C56.3554 68.5962 57.1578 69.0004 57.986 69.3863C58.3509 69.5564 58.7709 69.5564 59.1358 69.3863C59.964 69.0004 60.7661 68.5962 61.5422 68.1758C74.3092 61.2591 80.0743 49.9622 80.0743 43.3125C80.0743 35.7032 74.5912 29.5356 67.8268 29.5356Z",
    fill: "#E23E5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0752 43.3122C80.0752 49.9619 74.3091 61.2584 61.5412 68.1751C60.7647 68.5948 59.9645 69.0007 59.1341 69.385C58.7696 69.5557 58.3508 69.5557 57.9862 69.385C57.1593 69.0007 56.3557 68.5952 55.5792 68.1751C54.3705 67.5203 53.226 66.8267 52.1426 66.101C62.51 59.1593 67.2362 49.3324 67.2362 43.3122C67.2362 38.3488 64.9068 34.0008 61.4094 31.5743C63.2762 30.2827 65.4742 29.5356 67.827 29.5356C74.5927 29.5356 80.0752 35.7016 80.0752 43.3122Z",
    fill: "#B12841"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#3A8761"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_2721",
    x: -59,
    y: -44,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_2721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_2721",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeathBenefitInsurance);
export default __webpack_public_path__ + "static/media/imgDeathBenefitInsurance.6b838ebd861a48125760fffaa5014aa3.svg";
export { ForwardRef as ReactComponent };